// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2UNMl","overflowing":"ReadFullNote_overflowing__1AIVO"};